import React from "react";

function Service({ service }) {
  const { title, content, icon, color } = service;
  const hexToRgb = (hex) => {
    const temp = hex
      .replace(
        /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
        (m, r, g, b) => "#" + r + r + g + g + b + b
      )
      .substring(1)
      .match(/.{2}/g)
      .map((x) => parseInt(x, 16));
    return temp.join(",");
  };

  return (
    <div
      className="service-box rounded padding-30 shadow-blue"
      style={{
        "--service-accent": color,
        "--service-accent-rgb": hexToRgb(color),
      }}
    >
      <div className="service-icon">
        <img src={icon} alt={title} />
      </div>
      <h3 className="mb-3 mt-0">{title}</h3>
      <p className="mb-0">{content}</p>
    </div>
  );
}

export default Service;
